/* eslint-disable max-len, max-lines */
import {getContent, getPatchNote, PatchNote, PatchNoteContent, PatchNoteType} from './UIPatchNoteModule'

export class PatchNoteData {
    protected readonly patchNotes: PatchNote[]
    protected readonly announcement: string[]

    constructor() {
        this.patchNotes = []
        this.announcement = []

        this.announcement.push('<b>JOIN THIS WEEKEND\'S 4P TOURNAMENT!!! <a href="https://tinyurl.com/colonist4ptourney14" target="_blank">REGISTER HERE</a></b>')
        this.announcement.push('<a href="https://tinyurl.com/colonist4ptourney14" target="_blank"><img src="/dist/images/announcement_colonist_tournament.png?rev=" style="width: 100%"></a>')
        // this.announcement.push('<a href="https://www.youtube.com/@colonistio/?sub_confirmation=1" target="_blank"><img src="/dist/images/announcement_colonist_con_24.png" style="width: 100%"></a>')
        // this.announcement.push('Check out our latest video! </b><a href="https://youtu.be/R_hl_CAefrg" target="_blank">1 v 1 Guide!</a>!</b>')
        // this.announcement.push('<iframe style="display: block; margin: 0 auto;" width="560" height="315" src="https://www.youtube.com/embed/xtkDDYhfMHw?si=CugURvk5342Fyj02" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>')
        // this.announcement.push('<b>We are looking for a Community Manager. Check out <a href="/careers" target="_blank">careers</a>!</b>')
        // this.announcement.push('<a href="https://blog.colonist.io/colonist-io-2023-summary/"><img src="/dist/images/announcement_2023yearlystats.png" style="width: 100%"></a>')
        // this.announcement.push('<a href="/store#gift"><img src="/dist/images/announcement_gift.png" style="width: 100%"></a>')

        // Jeff

        // Andre

        // Rob

        // Devyesh

        // Oguz

        // Stan

        // Muhammad

        // Marc

        // Dang

        // Kyle

        // ! PUBLIC PN FORMAT: vxxx.push(getContent(PatchNoteType.xxx, 'Description', ['Thanks to'], 'Before .png', 'After .png', ['FeatureUpvote link']))

        const v258: PatchNoteContent[] = []
        v258.push(getContent(PatchNoteType.Update, '[Mobile] Search players in profile page', undefined, undefined, 'https://imgur.com/a/mnffGIU'))
        v258.push(getContent(PatchNoteType.Fix, 'Fixed clicking your flag opening both the change region popup and leaderboard filter', undefined, undefined, undefined))

        // Devyesh
        // Migration to support local currency in transactions

        // Marc
        // Add a new reward to the referral program

        // Dang
        // Enable Replay for Specators after a live game

        this.patchNotes.push(getPatchNote(2025, 6, 24, 258, v258))

        const v257: PatchNoteContent[] = []
        v257.push(getContent(PatchNoteType.Update, 'New Edit Profile popup', undefined, 'https://imgur.com/a/NJoBkLF', 'https://imgur.com/a/qWWctoF'))
        v257.push(getContent(PatchNoteType.Update, '[Mobile] Added a search undo button to the leaderboard', undefined, 'https://imgur.com/a/g1IHLGF', 'https://imgur.com/a/kOIoXx1'))
        v257.push(getContent(PatchNoteType.Fix, '[Tablet] Fixed overflowing game mode buttons', undefined, 'https://imgur.com/a/EscmyYd', 'https://imgur.com/a/MxRmn73'))
        v257.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed accidental interactions with elements behind popups'))
        v257.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed slider minimum value for Card Discard Limit', undefined, 'https://i.imgur.com/wj5BYIM.jpeg', 'https://i.imgur.com/XAdf0rM.jpeg'))

        // Rob
        // Add analytic event for ranked info icon

        // Devyesh
        // [Mobile] Refactor leaderboard - phase 3
        // [Mobile] Added endpoint to check active subscriptions
        // [Mobile] Close singleton pages when entering game

        // Oguz
        // Add Growthbook instructions to ab test documentation
        // Fixed missing currency sign in the store

        // Muhammad
        // always lineup page content with header/footer

        // Marc
        // AB test two different texts for the share activity invitation on Discord

        // Kyle
        // cancel membership via discord steps added to faq

        this.patchNotes.push(getPatchNote(2025, 6, 17, 257, v257))

        const v256: PatchNoteContent[] = []
        v256.push(getContent(PatchNoteType.Update, 'Large notification count now shows 99+', undefined, 'https://imgur.com/D6f9umF', 'https://imgur.com/o2ywUxp'))
        v256.push(getContent(PatchNoteType.Fix, 'Fixed received friend requests not showing up on some pages'))
        v256.push(getContent(PatchNoteType.Fix, '[Discord Activity] Fixed the leaderboard Membership icon opening the store and profile page at the same time', undefined, 'https://imgur.com/a/fJDpV4a', 'https://imgur.com/a/8IUDLjj'))
        v256.push(getContent(PatchNoteType.Fix, '[Discord Activity] Fixed clicking on the leaderboard flag icon opening profile page', undefined, 'https://imgur.com/a/LenUbNC', 'https://imgur.com/a/tXpaH94'))
        v256.push(getContent(PatchNoteType.Fix, '[Mobile] Increase profile page view height', undefined, 'https://imgur.com/a/1vMRQ7q', 'https://imgur.com/a/DJ95CmL'))

        // Devyesh
        // [Mobile] Added endpoint to check active subscriptions
        // [Mobile] Fixing UI on first load in mobile app
        // [Mobile] Fix UI breaking when selecting avatar
        // [Mobile] Added payments in mobile app
        // [Mobile] Fixing deeplink to iOS app
        // Removed ads from matchmaking page on Android

        // Oguz
        // Stop STORE_YEARLY_MEMBERSHIP_PRICE_ADJUSTMENT A/B test
        // Fixed game breaking edge case in tournament rooms
        // Added unit tests for tournament rooms

        // Muhammad
        // add no trolls to mobile rules
        // remove check/X buttons from popups that don't need them
        // adjust spacing between sections on singleton pages

        // Marc
        // AB test to reactivate Discord inactive users by sending DMs with our Discord bot

        this.patchNotes.push(getPatchNote(2025, 6, 10, 256, v256))

        const v255: PatchNoteContent[] = []
        v255.push(getContent(PatchNoteType.Update, 'Show max values in room sliders', undefined, 'https://i.imgur.com/HtTQkjU.png', 'https://i.imgur.com/MFqT6JQ.png'))
        v255.push(getContent(PatchNoteType.Update, '[Mobile] Updated profile page styles', undefined, 'https://imgur.com/a/IyjTcni', 'https://imgur.com/a/rDe6avP'))
        v255.push(getContent(PatchNoteType.Update, '[Mobile] Swapped map and edit icons in room settings', undefined, 'https://imgur.com/a/DXYc6oT', 'https://imgur.com/a/0L03IZd'))
        v255.push(getContent(PatchNoteType.Update, '[Mobile] Improved friends view in profile', undefined, 'https://imgur.com/a/KauPq75', 'https://imgur.com/a/yZ9Trlr'))
        v255.push(getContent(PatchNoteType.Update, '[Mobile] Updated splash screen image and font sizes', undefined, undefined, undefined))

        // Rob
        // [Mobile] Consistent ranked/casual button text
        // Beginner mode button shows on mobile when you have 0 or 1 games
        // Fix homepage ranked lock icon
        // Add X button to delete account popup
        // [Mobile] Increase side menu font size
        // Remove background image from store popups

        // Devyesh
        // [Mobile] Minor leaderboard refactor - 2
        // [Mobile] Standarize popup styles in mobile

        // Oguz
        // Rename Card.tsx as UIGameCard.tsx and add optional count prop

        this.patchNotes.push(getPatchNote(2025, 6, 3, 255, v255))

        const v254: PatchNoteContent[] = []
        v254.push(getContent(PatchNoteType.Update, 'Remove Wins/Loss and Completed Games stats from profile', undefined, 'https://imgur.com/a/y5GsCoz', 'https://imgur.com/a/yn15zvm'))
        v254.push(getContent(PatchNoteType.Update, 'Remove Wins/Loss stat from homepage', undefined, 'https://imgur.com/a/UMfR1cN', 'https://imgur.com/a/yceH7R6'))
        v254.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed mobile lobby header position', undefined, 'https://i.imgur.com/qKecl3S.jpeg', 'https://i.imgur.com/YaCSqym.jpeg'))
        v254.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed player count display on mobile', undefined, 'https://i.imgur.com/Ps3grZQ.png', 'https://i.imgur.com/f74MbPZ.png'))
        v254.push(getContent(PatchNoteType.Fix, '[Mobile] Automatically open the keyboard when showing a popup with text box'))

        // Devyesh
        // [Mobile] Merged UILeaderboardBaseTableRowView with UIMLeaderboardBaseTableRowView
        // [Mobile] Use UserAgent instead of isTablet to detect tablet devices on events
        // [Mobile] Handle error screen when socket is established after the error is shown
        // [Mobile] Set default resolution to min of 2 or devicePixelRatio
        // [Mobile] Added starting userId to AuthMigration

        // Oguz
        // Created /banmostreportedplayers command
        // Implemented UIGameTimer React Component
        // Added Google Tag Manager events

        this.patchNotes.push(getPatchNote(2025, 5, 27, 254, v254))

        const v253: PatchNoteContent[] = []
        v253.push(getContent(PatchNoteType.Update, '[Discord Activity] Invite Discord friends to a Colonist room when playing via direct messages'))

        // Devyesh
        // [Mobile] Use UserAgent instead of isTablet to detect tablet devices on events

        // Oguz
        // Implemented UIGameTimer React Component
        // Added Google Tag Manager events

        // Marc
        // Refactor Discord Bot reactivation messages
        // Make it possible to invite Discord friends to a room even when playing Colonist from a DM

        this.patchNotes.push(getPatchNote(2025, 5, 20, 253, v253))

        const v252: PatchNoteContent[] = []
        v252.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed end game screen not appearing on tablets'))
        v252.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed game rotation on tablet'))

        // Rob
        // Rename discord classes and variables
        // Rework Discord Mount architecture

        // Devyesh
        // [Mobile] Support tablet mode on website

        // Oguz
        // Added Google Tag Manager events
        // Implemented store yearly subscriptions LTV A/B test

        // Stan
        // Added rate chat experience notification on end game screen
        // Replaced HowlerJS with AudioManager + Web Audio API

        this.patchNotes.push(getPatchNote(2025, 5, 13, 252, v252))

        const v251: PatchNoteContent[] = []
        v251.push(getContent(PatchNoteType.Update, 'Players who quit now have 100 seconds to rejoin before the game ends automatically'))
        v251.push(getContent(PatchNoteType.Fix, '[Discord] Fixed invite online friends button not working'))

        // Rob
        // Rename discord classes and variables

        // Devyesh
        // [Mobile] Bumps @babel/helpers from 7.26.9 to 7.27.0.
        // [Mobile] Bumps @babel/runtime from 7.26.9 to 7.27.0.
        // [Mobile] Fixing app related issues
        // [Mobile] Android full screen mode fixed
        // [Mobile] Added landscape mode is deprecated popup. Also removes toggle for new players

        // Marc
        // Catch error when sending DM 24h after last activity launch and ignore if user cannot receive messages

        this.patchNotes.push(getPatchNote(2025, 5, 6, 251, v251))

        const v250: PatchNoteContent[] = []
        v250.push(getContent(PatchNoteType.Update, 'Add friends from the room', undefined, undefined, 'https://imgur.com/a/JmLOT3I'))
        v250.push(getContent(PatchNoteType.Update, 'Redesigned top notification banners', undefined, 'https://imgur.com/a/T4ocWXF', 'https://imgur.com/a/ujkJ8Ov'))

        // Devyesh
        // [Mobile] Migrate apple users from old account to new account

        // Muhammad
        // cleanup console logs in prod & dev
        // web and discord default rooms settings now the same (except discord is private and karma inactive)
        // v250.push(getContent(PatchNoteType.Update, '[Mobile] Improved store sidebar style', undefined, 'https://imgur.com/a/DP7uZMm', 'https://imgur.com/a/vOeAOKC'))

        // Marc
        // New popup when returning to homepage at the end of a game to promote the rewards program
        // New Lobby Ad to promote the rewards program

        this.patchNotes.push(getPatchNote(2025, 4, 29, 250, v250))
    }

    getContributionCount(username: string): number {
        let count = 0
        for(const pn of this.getAll()) {
            for(const content of pn.contents) {
                for(const contributor of content.contributors) {
                    if(contributor == username) count += 1
                }
            }
        }
        return count
    }

    getAnnouncements(): string[] {
        return this.announcement
    }

    getAll(): PatchNote[] {
        return this.patchNotes
    }

    getLast5(): PatchNote[] {
        return this.patchNotes.slice(0, 5)
    }

    getLatest(): PatchNote[] {
        return this.patchNotes.slice(0, 1)
    }
}
